import { gql } from "@apollo/client";

export const GET_ATTACHMENT = gql`
  query attachment($id: ID!) {
    attachment(id: $id) {
      id
      subParentId
      name
      description
      fileUrl
      extension
    }
  }
`;

export const GET_ATTACHMENTS = gql`
  query attachments(
    $parentId: ID!
    $searchTerm: String
    $first: Int
    $after: String
    $before: String
  ) {
    attachments(
      parentId: $parentId
      searchTerm: $searchTerm
      first: $first
      after: $after
      before: $before
    ) {
      edges {
        cursor
        node {
          id
          subParentId
          name
          description
          fileUrl
          extension
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        total
      }
    }
  }
`;

export const CREATE_EXISTING_ATTACHMENT = gql`
  mutation createExistingAttachment($input: CreateExistingAttachmentInput!) {
    createExistingAttachment(input: $input) {
      parentId
      parentType
      subParentId
    }
  }
`;

export const UPDATE_ATTACHMENT = gql`
  mutation updateAttachment($id: ID!, $input: UpdateAttachmentInput!) {
    updateAttachment(id: $id, input: $input) {
      id
      subParentId
      name
      description
      fileUrl
    }
  }
`;

export const DELETE_ATTACHMENT = gql`
  mutation deleteAttachment($id: ID!) {
    deleteAttachment(id: $id) {
      id
    }
  }
`;
